var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBelliconactive = function SvgBelliconactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.755%",
    y1: "0%",
    x2: "63.537%",
    y2: "109.395%",
    id: "belliconactive_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#212121",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.733 22.581H2.093a2.087 2.087 0 0 1-1.255-3.76l.94-.704c.353-.264.59-.655.661-1.09l1.18-7.148a7.884 7.884 0 0 1 7.797-6.672 7.884 7.884 0 0 1 7.792 6.678l1.178 7.142c.071.435.309.826.662 1.09l.94.703a2.087 2.087 0 0 1-1.255 3.761Zm-9.32-18.234a6.706 6.706 0 0 0-6.668 5.711l-1.18 7.154a2.836 2.836 0 0 1-1.103 1.816l-.94.704a.949.949 0 0 0 .57 1.71h18.642a.95.95 0 0 0 .57-1.71l-.94-.704a2.836 2.836 0 0 1-1.104-1.816l-1.18-7.148a6.707 6.707 0 0 0-6.666-5.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.624a.57.57 0 0 1-.571-.57V2.28a1.14 1.14 0 0 0-2.282 0v.775a.57.57 0 0 1-1.142 0V2.28A2.28 2.28 0 0 1 11.413 0a2.28 2.28 0 0 1 2.282 2.28v.774a.57.57 0 0 1-.57.57ZM11.413 26a3.996 3.996 0 0 1-3.995-3.989.57.57 0 0 1 1.142 0 2.851 2.851 0 0 0 2.853 2.85 2.851 2.851 0 0 0 2.853-2.85.57.57 0 0 1 1.141 0A3.996 3.996 0 0 1 11.413 26Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#belliconactive_svg__a)",
    cx: 18.86,
    cy: 8.821,
    rx: 4.14,
    ry: 4.179
  }))));
};
export default SvgBelliconactive;